// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.dark-mode .scrollable-requester-list {\r\n  background-color: #2d3748;\r\n  color: #a0aec0;\n}\n.scrollable-requester-list {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n  border: 1px solid #ccc;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
